import api from '../connectors/Api'

const API = api()

export default {
  namespaced: true,
  state: {
    reports: {}
  },
  mutations: {
    setReports (state, { campaignId, reports }) {
      const newReports = { ...state.reports }
      newReports[campaignId] = reports
      state.reports = newReports
    }
  },
  actions: {
    getReport ({ commit, state, dispatch }, campaignId) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.getCampaignReportInfluencer(token, campaignId)
            .then((res) => {
              commit('setReports', { campaignId, reports: res.body })
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    saveReport ({ commit, state, dispatch }, { campaignId, data }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.saveCampaignReportInfluencer(token, campaignId, data)
            .then((res) => {
              dispatch('getReport', campaignId)
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    }
  }
}
